<template>
  <div class="bg-white sp-container-padding sp-rounded-lg">
    <div class="flex">
      <div class="h-6 flex items-center justify-center" style="min-width: 24px">
        <img class="w-5 h-5" src="@/assets/icons/AlertCircle.svg" alt="" />
      </div>
      <div class="ml-2 title-md text-primary-light-high">
        PRONIアイミツメンバーズ（旧アイミツCLOUD）・PRONIアイミツ（旧アイミツ）のログインパスワードが共通化されます。
      </div>
    </div>
    <div class="mt-2 body-md">
      8月14日21時以降、最初にログインした方のパスワードが共通パスワードとして設定されます。<br />
      （パスワードはお手元に控えて頂くことを推奨します）
    </div>
    <div class="mt-1 body-sm text-gray-62">
      ※ログインができない・パスワードをお忘れの方は<router-link
        class="underline"
        :to="{ name: 'PasswordResetRequest' }"
        >こちら</router-link
      >よりパスワード再設定をお願いします。
    </div>
  </div>
</template>
<script></script>
<style lang="scss" scoped>
.sp-container-padding {
  padding: 1.5rem 2rem;
}
.sp-rounded-lg {
  border-radius: 0.5rem;
}

@media (max-width: 640px) {
  .sp-container-padding {
    padding: 1rem;
  }
  .sp-rounded-lg {
    border-radius: 0;
  }
}
</style>
